module.exports = __webpack_public_path__ + "img/SABEN.6ee6c378.png";